import { render } from "./indexCard.vue?vue&type=template&id=6e61a560"
import script from "./indexCard.vue?vue&type=script&lang=js"
export * from "./indexCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__